import React from 'react';
import { Star, Quote, Users, TrendingUp, Clock } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Carlos Silva',
      role: 'Marceneiro',
      company: 'Silva Marcenaria',
      avatar: 'C',
      text: 'Economizo 2 horas por dia desde que comecei a usar. Meus clientes elogiam os orçamentos profissionais!',
      rating: 5,
      highlight: 'Economizo 2h/dia'
    },
    {
      name: 'Ana Costa',
      role: 'Proprietária',
      company: 'Salão Beleza Premium',
      avatar: 'A',
      text: 'O agendamento automático mudou meu negócio. Nunca mais perdi cliente por esquecimento. Recomendo demais!',
      rating: 5,
      highlight: 'Zero clientes perdidos'
    },
    {
      name: 'Roberto Oliveira',
      role: 'Dono',
      company: 'Oficina Automotiva',
      avatar: 'R',
      text: 'O ClienteJá me ajuda a cobrar sem constrangimento. As parcelas são controladas automaticamente. Excelente!',
      rating: 5,
      highlight: '+40% em cobranças'
    }
  ];

  const stats = [
    { icon: Users, value: '500+', label: 'Profissionais ativos' },
    { icon: TrendingUp, value: '98%', label: 'Taxa de satisfação' },
    { icon: Clock, value: '2h', label: 'Economia diária média' },
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 rounded-full text-green-700 text-sm font-medium mb-4">
            <Star size={16} fill="currentColor" />
            Aprovado por profissionais
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Quem usa, recomenda
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Veja o que profissionais como você estão falando sobre o AtivaJá
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-12">
          {stats.map((stat, i) => (
            <div key={i} className="text-center p-6 bg-white rounded-2xl border border-slate-100 shadow-sm">
              <stat.icon className="w-8 h-8 text-blue-600 mx-auto mb-3" />
              <div className="text-3xl font-bold text-slate-900 mb-1">{stat.value}</div>
              <div className="text-sm text-slate-500">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div 
              key={i} 
              className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-lg hover:border-blue-100 transition-all duration-300"
            >
              {/* Quote Icon */}
              <Quote size={32} className="text-blue-100 mb-4" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={j} size={16} className="text-amber-400" fill="currentColor" />
                ))}
              </div>

              {/* Text */}
              <p className="text-slate-600 mb-6 leading-relaxed">
                "{t.text}"
              </p>

              {/* Highlight Badge */}
              <div className="inline-flex px-3 py-1 bg-green-50 text-green-700 text-xs font-medium rounded-full mb-4">
                {t.highlight}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold">
                  {t.avatar}
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{t.name}</div>
                  <div className="text-sm text-slate-500">{t.role} • {t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-12 pt-12 border-t border-slate-200">
          <p className="text-center text-sm text-slate-400 mb-6">Integrações e parceiros</p>
          <div className="flex flex-wrap items-center justify-center gap-8 opacity-50 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-500">
            <div className="flex items-center gap-2 text-slate-600">
              <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center text-white text-xs font-bold">W</div>
              <span className="font-medium">WhatsApp</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white text-xs font-bold">A</div>
              <span className="font-medium">Asaas</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center text-white text-xs font-bold">Z</div>
              <span className="font-medium">Z-API</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center text-white text-xs font-bold">AI</div>
              <span className="font-medium">OpenAI</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
